import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import { DownloadLeaderboardExcelRequest, ViewLeaderboardRequest } from './leaderboard.types';

export const requestViewLeaderboard =
  createAction<SagaPayload<ViewLeaderboardRequest>['payload']>('request/viewLeaderboard');

export const requestDownloadLeaderboardExcel = createAction<
  SagaPayload<DownloadLeaderboardExcelRequest, string>['payload']
>('request/downloadLeaderboardExcel');
